export { default } from './PopQuizBanner.qmee';
export type { PopQuizBannerProps } from './PopQuizBanner.qmee';
